function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeMiterlimit: 10,
  d: "M22 2.75v18.5"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M9 6.5h12v11H9z"
});

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24"
  }, props), _ref, _ref2);
};

export default SvgComponent;